var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingIconsmain({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6682 0.40416C11.8142 0.423222 11.9554 0.466988 12.0862 0.533066L12.2131 0.606308C12.3772 0.714022 12.5148 0.857771 12.6155 1.02623C12.7148 1.19233 12.775 1.37858 12.7932 1.57115H12.7942L12.8 1.70299V7.34361L12.9612 7.37584L16.7551 8.13658C16.9949 8.1844 17.2159 8.29799 17.3928 8.46471L17.4651 8.5399C17.6511 8.74572 17.7665 9.00522 17.7942 9.28111L17.8 9.41881V17.2001H19.0002C19.2039 17.2004 19.3999 17.2781 19.5481 17.4178C19.6963 17.5578 19.7861 17.7495 19.7981 17.953C19.81 18.1565 19.7434 18.3572 19.6125 18.5135C19.4818 18.6697 19.2962 18.7696 19.094 18.7938L19.0002 18.7997H1.00024L0.849854 18.785C0.701744 18.7565 0.563613 18.6868 0.452393 18.5819C0.341311 18.477 0.262964 18.3432 0.22583 18.1971L0.202393 18.0467C0.193459 17.894 0.228668 17.7431 0.302002 17.6112L0.387939 17.4862C0.518324 17.3306 0.703048 17.2304 0.904541 17.2059L1.01196 17.2001H2.20044V4.36021C2.20044 3.84171 2.50687 3.37797 2.97485 3.17076L3.0979 3.12389L3.09692 3.12291L11.0891 0.459824C11.2288 0.413321 11.3752 0.390953 11.5217 0.393417L11.6682 0.40416ZM10.9368 2.1981L3.93677 4.53111L3.80005 4.57701V17.2001H11.2004V2.11021L10.9368 2.1981ZM16.2004 9.65611L16.0393 9.62389L13.0393 9.02525L12.8 8.9774V17.2001H16.2004V9.65611Z",
    fill: "#909090",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIconsmain);
export default __webpack_public_path__ + "static/media/buildingIconsmain.331c7a2fe6743bad44f0d102c4a2928f.svg";
export { ForwardRef as ReactComponent };